
import { useNavigate } from "react-router-dom";

/**
 * Hook for handling dealer card navigation
 */
export function useDealerNavigation() {
  const navigate = useNavigate();
  
  /**
   * Creates a URL path for the dealer based on city context
   */
  const createDealerUrl = (dealerId: string, city?: string) => {
    // Extract city from address if not provided
    let citySlug = 'roma'; // Default city
    
    if (city) {
      // Use provided city if available
      citySlug = city.toLowerCase().replace(/[^\w\s]/gi, '').replace(/\s+/g, '-');
    }
    
    // Get the current URL to check if we're already on a city page
    const currentPath = window.location.pathname;
    const pathParts = currentPath.split('/');
    
    // If we're already on a city page, use that city in the URL
    if (pathParts.length >= 3 && pathParts[1] === 'compro-oro' && pathParts[2]) {
      const currentCitySlug = pathParts[2];
      
      // Always use the current city from the URL if we're on a compro-oro page
      citySlug = currentCitySlug;
      
      // If we're on a dealer detail page, extract just the city part
      if (pathParts.length > 3) {
        // Make sure we're not using a dealer ID as a city
        const possibleDealerId = pathParts[3];
        if (possibleDealerId !== dealerId) {
          citySlug = currentCitySlug;
        }
      }
    }
    
    return `/compro-oro/${citySlug}/${dealerId}`;
  };
  
  /**
   * Navigate to dealer details page
   */
  const navigateToDealer = (dealerId: string, city?: string) => {
    const url = createDealerUrl(dealerId, city);
    navigate(url);
  };
  
  return {
    createDealerUrl,
    navigateToDealer
  };
}
